<template>
    <b-modal centered :title="title" header-bg-variant="light" header visible v-on="$listeners">
        <h6>Выберите сертификат</h6>
        <ecp-select v-model="cert" />
        <ecp-cert-card v-if="cert" :cert="cert" class="mt-3" />
        <template slot="modal-footer">
            <slot name="modal-footer" :on-sign="onSign" :loginEnabled="loginEnabled" :close="() => { $emit('hidden') }">
                <b-button @click="$emit('hidden')" variant="danger">Отменить</b-button>
                <b-button @click="onSign" variant="success" :disabled="!cert">
                    <fa class="mr-2" :icon="['fas', 'key']" />
                    Подписать
                </b-button>
            </slot>
        </template>
        <b-modal centered title="Выберите логин" :visible="usersList && usersList.length > 0" @hidden="() => $emit('hidden') ">
            <b-form-select v-model="userId" :options="usersList"/>
            <template slot="modal-footer">
                <b-button @click="onSign" variant="success" :disabled="!userId">
                    <fa class="mr-2" :icon="['fas', 'key']" />
                    Войти
                </b-button>
            </template>
        </b-modal>
    </b-modal>
</template>

<script>
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import EcpSelect from './EcpSelect'
import EcpCertCard from './EcpCertCard'
import { createSignature } from 'crypto-pro'

library.add(faKey);

export default {
    name: "EcpModal",
    components: { EcpCertCard, EcpSelect },
    props: {
        hash: {
            type: String,
        },
        title: {
            type: String,
            default: "Подтверждение подписи",
        },
        attached: {
            type: Boolean,
        },
        usersList: {
            type: Array,
            required: false,
            default: () => [],
        }
    },
    data() {
        return {
            cert: null,
            userId: null
        }
    },
    computed: {
        loginEnabled() {
            return !!this.cert
        }
    },
    methods: {
        onSign() {
            if (!this.cert) {
                return this.$emit("sign", 'sign');
            }
            if (this.hash) {
                return createSignature(this.cert.thumbprint, this.hash, !this.attached).then(sign => {
                    this.$emit("sign", sign.replace(/[\n\r]/g, ""), this.userId);
                });
            } else {
                return this.$emit("sign", this.cert.thumbprint, this.userId);
            }
        },
    },
};
</script>
